import { Link } from '@afterpaytouch/core'
import clsx from 'clsx'
import { Trans } from '../../utils/convergence'
import React from 'react'

import { AssetLayout } from '.'
import { DEFAULT_ASSET_VERSION, PostCheckoutFlow } from '../../model'
import { useCheckoutToken, useConsumerSelector, useMerchantDisplayNameOrName, useSendNotificationMutation } from '../../state'
import {
  PostCaptureHeader,
  Progress,
  Subtitle,
  HeroTitle,
  PrimaryTitle,
  SecondaryTitle,
  CallToAction,
  ThankYou,
  FinePrint,
  FooterLink,
  Image,
} from './component'

import styles from './styles.module.css'

export const GiftCard: AssetLayout = ({
  onSkipActionClick = () => {},
  actioned,
  assetId,
  flow,
  showProgressBar,
  disabled,
  finePrint,
  footerLinkTitle,
  onNegativeActionClick = () => {},
  onPrimaryActionClick = () => {},
  heroTitle,
  postCaptureConfirmTitle,
  postCaptureConfirmDescription,
  primaryTitle,
  privacyPolicyUrl,
  secondaryTitle,
  selectedOption,
  thankyouTitle,
}) => {
  const { email } = useConsumerSelector()
  const merchantName = useMerchantDisplayNameOrName()
  const cardStyle = clsx([styles.assetPaddedCard, styles.assetPaddingSmall])
  const [triggerNotification] = useSendNotificationMutation()
  const token = useCheckoutToken()

  const handlePrimaryActionClick = async (e: React.SyntheticEvent<HTMLInputElement, Event>): Promise<void> => {
    onPrimaryActionClick(e)
    try {
      await triggerNotification({
        assetId,
        assetVersion: DEFAULT_ASSET_VERSION,
        orderTransactionToken: token,
      }).unwrap()
    } catch (e) {
      // log error event?
      console.error('error triggering notification')
    }
  }

  return (
    <>
      <PostCaptureHeader
        title={postCaptureConfirmTitle}
        description={
          <Trans
            i18nKey={postCaptureConfirmDescription ?? ''}
            tOptions={{ email, merchantName }}
            components={{
              merchantLink: <Link onClick={onSkipActionClick} kind='Underline' />,
            }}
          />
        }
        show={flow === PostCheckoutFlow.PostCapture}
      />
      <Progress show={flow === PostCheckoutFlow.PreCapture} visible={showProgressBar} />
      <Subtitle />
      <div className={cardStyle}>
        <Image show={!actioned} alt={primaryTitle} hasVariantImages />
        <HeroTitle label={heroTitle} />
        <PrimaryTitle show={!actioned} label={primaryTitle} />
        <SecondaryTitle show={!actioned} label={secondaryTitle} />
        <CallToAction
          show={!actioned}
          id={assetId}
          onPrimaryActionClick={handlePrimaryActionClick}
          onNegativeActionClick={onNegativeActionClick}
          testNameSpace='postCheckout-cta'
          disabled={disabled}
        />
        <ThankYou show={actioned} selected={selectedOption} label={thankyouTitle} />
        <FinePrint show={!actioned} label={finePrint} privacyUrl={privacyPolicyUrl} testNameSpace={assetId} />
      </div>
      <FooterLink disabled={disabled} onClick={actioned ? onSkipActionClick : onNegativeActionClick}>
        {footerLinkTitle}
      </FooterLink>
    </>
  )
}
